export default __webpack_public_path__ + "static/media/dummuMeterIcon.56f2c8b6.svg";